import { render, staticRenderFns } from "./CustomersLanguages.vue?vue&type=template&id=7405e12e&scoped=true&"
import script from "./CustomersLanguages.vue?vue&type=script&lang=ts&"
export * from "./CustomersLanguages.vue?vue&type=script&lang=ts&"
import style0 from "./CustomersLanguages.vue?vue&type=style&index=0&id=7405e12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7405e12e",
  null
  
)

export default component.exports